import type { SVGProps } from 'react';

export const TransactionTwoWayIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 16 16"
      fill="none"
      strokeWidth="1.4"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.5 1.5L1.5 4.5L4.5 7.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13.5 4.5H1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11.5 8.5L14.5 11.5L11.5 14.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2.5 11.5H14.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
